
import React , {Component, useState, useEffect, useContext   }  from "react";
import {  useNavigate  } from "react-router-dom";
import { Cookies } from '../../index.js';
import StatusBadge  from "../../js/buttonstatus.jsx";
import AdSense from 'react-adsense';
import { alert_error , alert_success  } from '../../AppContext.js';
import axios from "axios";
import queryString from 'query-string';
const Listaccount = () => {
  const navigate = useNavigate();
  const [dulieudonhang, setdulieudonhang] = useState([
    {
      id: 1,
      view: 100,
      verified: 50,
      service_name: "Đang tải danh sách vui lòng đợi",
      url: "Đang tải danh sách vui lòng đợi",
      capdo: 10,
      status: 'show',
      note: "Note 1",
      updatedate: "2023-04-05",
    }
  ]);
  const laynhatky = async () => {
    const myCookieValue = Cookies.get('apikey');


    try {
      const response = await axios.get('https://hust.media/nosql/shop/accounts/list.php' );
      if ( response.data != '' )
  {
  
  setdulieudonhang(response.data) ;

  }
  
   
    } catch (error) {
  
    }
  };
  function saochep(value) {
    alert_success('Đã sao chép') ;
    window.saochepnative(value);

  };
  function switch_router(link) {
    navigate(link);
  };
  useEffect(() => {

    laynhatky();
  }, []);
  return (
    <>
  
 
        <div className="mx-2 ">
        { dulieudonhang && (
        <>
   <div className="max-h-16 mx-4">
                <div className="cards">
    <AdSense.Google
          client="ca-pub-4574266110812955"
          slot="1627514116"
          style={{ display: 'block', height: 50 }}
          format=""
        /> </div>
        </div>
        </>
    )}
    <div className="table-responsive overflow-x-hidden">
    <table className="table align-middle table-flush table-sm table-bordered">
        <thead className="thead-light">
          <tr>
            <th className="text-lowercase text-center" style={{ width: "10%" }} scope="row">
              Thông tin chung
            </th>
            <th className="text-center" style={{ width: "15%" }} scope="row">
            dịch vụ
            </th>
            <th className="text-center" style={{ width: "10%" }} scope="row">
              Mô tả
            </th>
            <th className="text-center" style={{ width: "10%" }} scope="col">
              THỜI GIAN
            </th>
          </tr>
        </thead>
        <tbody>
          {dulieudonhang.map((item, index) => (
            <tr key={index}>
              <td className="text-center">
              <button style={{textDecoration: 'none'}} onClick={() => switch_router( '/shop/profile/' + item.username)}  >
              {item.username}
                </button>     
                <br />

                <span className="badge badge-default">
                  <img src={"https://hust.media/nosql/shop/accounts/img/" + item.id + '.png' } alt="Girl in a jacket" className="w-14 h-14" />

                </span>
              </td>
              <td className="text-center">
                
                <span className="text-lowercase bg-danger badge rounded-pill text-wrap">
                  <b className="text-white">{item.caption}</b>
                </span>
              <p className="mb-0 text-xs">  mô tả </p><div className="text-sm mt-0 text-lowercase text-black  badge rounded-pill text-wrap">
              {item.mota}
              </div>
              </td>
       
              <td className="text-center">
          
                <b style={{ color: "red" }}>{item.capdo}</b>
                <div style={{ width: "100%" }} className="text-lowercase text-wrap text-sm">
         còn lại {item.amount},đã bán {item.sold}
           </div>
                <div style={{ width: "100%" }} className="text-lowercase text-wrap text-xs">
               Xác thực 2 bước {item.twofa}
                </div>
              </td>
              <td className="text-center">

                <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                Giá {item.money}
                </div>
                  <button className="text-lowercase text-wrap" >
                    mua ngay
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>  </div></>
  );
};

export default Listaccount;
